import { defineComponent as d, renderSlot as f, getCurrentInstance as u, onMounted as a, onBeforeUnmount as m } from "vue";
import i from "./highrise1350.mjs";
import { warn as o } from "./highrise1351.mjs";
const x = d({
  name: "ResizeObserver",
  props: {
    onResize: Function
  },
  setup(s) {
    let n = !1;
    const r = u().proxy;
    function l(e) {
      const { onResize: t } = s;
      t !== void 0 && t(e);
    }
    a(() => {
      const e = r.$el;
      if (e === void 0) {
        o("resize-observer", "$el does not exist.");
        return;
      }
      if (e.nextElementSibling !== e.nextSibling && e.nodeType === 3 && e.nodeValue !== "") {
        o("resize-observer", "$el can not be observed (it may be a text node).");
        return;
      }
      e.nextElementSibling !== null && (i.registerHandler(e.nextElementSibling, l), n = !0);
    }), m(() => {
      n && i.unregisterHandler(r.$el.nextElementSibling);
    });
  },
  render() {
    return f(this.$slots, "default");
  }
});
export {
  x as default
};
